import french24 from "../assets/images/products/french-24.jpeg";
import gold24 from "../assets/images/products/gold-24.jpg";
import classic24 from "../assets/images/products/classic-24.jpeg";
import modern24 from "../assets/images/products/modern-24.jpeg";
import classic20 from "../assets/images/products/classic-20.jpeg";
import classic12 from "../assets/images/products/classic-12.jpg";
import gold10 from "../assets/images/products/gold-10.png";
import modern36 from "../assets/images/products/modern-36.png";
import modern20 from "../assets/images/products/modern-20.png";
import classic45 from "../assets/images/products/classic-45-b.png";
import gold16 from "../assets/images/products/gold-16.jpeg";
import gold36 from "../assets/images/products/gold-36b.jpeg";
import modern20silver from "../assets/images/products/modern-20-silver.jpeg";
import modern42 from "../assets/images/products/modern-42.png";
import classic12silver from "../assets/images/products/classic-12-silver.jpeg";
import floor6 from "../assets/images/products/floor-6-b.png";
import floor7 from "../assets/images/products/floor-7-b.png";
import wall1 from "../assets/images/products/wall-1.png";
import wall2 from "../assets/images/products/wall-2.png";
import gold15 from "../assets/images/products/gold-15.png";
import gold18 from "../assets/images/products/gold-18.png";
import gold54 from "../assets/images/products/gold-54.png";
import chrome40 from "../assets/images/products/chrome-40.png";
import modern12 from "../assets/images/products/modern-12.png";
import modern22 from "../assets/images/products/modern-22.png";

export const products = [
  {
    id: 1,
    name: "24 light French crystal Chandelier",
    dimensions: "W 125 cm x H 180 cm ",
    image: french24,
    isNew: true,
    lightNum: 24,
  },
  {
    id: 2,
    name: "24 light Gold crystal Chandelier",
    dimensions: "24″W x 24″D x 48″H",
    image: gold24,
    isNew: false,
    lightNum: 24,
  },
  {
    id: 3,
    name: "24 light Classic crystal Chandelier",
    dimensions: "1200mm D x 1300mm H",
    image: classic24,
    isNew: false,
    lightNum: 24,
  },
  {
    id: 4,
    name: "20 light Modern crystal Chandelier",
    dimensions: "1280mm D x 780mm H",
    image: modern24,
    isNew: true,
    lightNum: 20,
  },
  {
    id: 5,
    name: "20 light Classic crystal Chandelier",
    dimensions: "1340mm D x 920 mm H",
    image: classic20,
    isNew: false,
    lightNum: 20,
  },
  {
    id: 6,
    name: "12 light Classic crystal Chandelier",
    dimensions: "48″W x 12″D x 18″H",
    image: classic12,
    isNew: false,
    lightNum: 12,
  },
  {
    id: 7,
    name: "10 light Gold crystal Chandelier",
    dimensions: "Diameter: 880 mm x Height: 750 mm",
    image: gold10,
    isNew: false,
    lightNum: 10,
  },
  {
    id: 8,
    name: "36 light modern crystal Chandelier",
    dimensions: "1600mm D x 900mm H",
    image: modern36,
    isNew: false,
    lightNum: 36,
  },
  {
    id: 9,
    name: "20 light Modern crystal Chandelier",
    dimensions: "1150mm D x 640mm H",
    image: modern20,
    isNew: true,
    lightNum: 20,
  },
  {
    id: 10,
    name: "45 light classic crystal Chandelier",
    dimensions: "1600mm D x 1000mm H",
    image: classic45,
    isNew: true,
    lightNum: 45,
  },
  {
    id: 11,
    name: "16 light classic gold crystal Chandelier",
    dimensions: "18″W x 18″D x 24″H",
    image: gold16,
    isNew: false,
    lightNum: 16,
  },
  {
    id: 12,
    name: "36 light classic gold crystal Chandelier",
    dimensions: "1100 mm D x 725 mm H",
    image: gold36,
    isNew: false,
    lightNum: 36,
  },
  {
    id: 13,
    name: "20 light modern silver crystal Chandelier",
    dimensions: "610mm D x 980mm H",
    image: modern20silver,
    isNew: false,
    lightNum: 20,
  },
  {
    id: 14,
    name: "42 light modern gold crystal Chandelier",
    dimensions: "1000mm D x 850mm H",
    image: modern42,
    isNew: false,
    lightNum: 42,
  },
  {
    id: 15,
    name: "12 light classic silver crystal Chandelier",
    dimensions: "780mm D x 540mm H",
    image: classic12silver,
    isNew: false,
    lightNum: 12,
  },
  {
    id: 16,
    name: "6 light floor crystal Chandelier",
    dimensions: "540mm D x 880mm H",
    image: floor6,
    isNew: false,
    lightNum: 6,
  },
  {
    id: 17,
    name: "7 light floor crystal Chandelier",
    dimensions: "600mm D x 1700mm H",
    image: floor7,
    isNew: false,
    lightNum: 7,
  },
  {
    id: 18,
    name: "1 light wall crystal Chandelier",
    dimensions: "120mm L x 200mm W x 445mm H*",
    image: wall1,
    isNew: false,
    lightNum: 1,
  },
  {
    id: 19,
    name: "2 light wall crystal Chandelier",
    dimensions: "390mm L x 200mm W x 445mm H*",
    image: wall2,
    isNew: false,
    lightNum: 2,
  },
  {
    id: 20,
    name: "15 light classic gold crystal Chandelier",
    dimensions: "540mm D x 740mm H",
    image: gold15,
    isNew: false,
    lightNum: 15,
  },
  {
    id: 21,
    name: "18 light classic gold crystal Chandelier",
    dimensions: "960mm D x 780mm H",
    image: gold18,
    isNew: false,
    lightNum: 18,
  },
  {
    id: 22,
    name: "54 light classic gold crystal Chandelier",
    dimensions: "1750mm D x 1060mm H",
    image: gold54,
    isNew: false,
    lightNum: 54,
  },
  {
    id: 23,
    name: "40 light chrome crystal Chandelier",
    dimensions: "840mm D x 1380mm H",
    image: chrome40,
    isNew: false,
    lightNum: 40,
  },
  {
    id: 24,
    name: "12 light gold modern crystal Chandelier",
    dimensions: "1020mm D x 630mm H",
    image: modern12,
    isNew: false,
    lightNum: 12,
  },
  {
    id: 25,
    name: "22 light chrome modern crystal Chandelier",
    dimensions: "1650mm L x 820mm W x 520mm H",
    image: modern22,
    isNew: false,
    lightNum: 22,
  },
];
